import { render, staticRenderFns } from "./WorkspaceCfdeDatasetRunCard.vue?vue&type=template&id=661dfb4e&scoped=true"
import script from "./WorkspaceCfdeDatasetRunCard.vue?vue&type=script&lang=js"
export * from "./WorkspaceCfdeDatasetRunCard.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceCfdeDatasetRunCard.vue?vue&type=style&index=0&id=661dfb4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661dfb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661dfb4e')) {
      api.createRecord('661dfb4e', component.options)
    } else {
      api.reload('661dfb4e', component.options)
    }
    module.hot.accept("./WorkspaceCfdeDatasetRunCard.vue?vue&type=template&id=661dfb4e&scoped=true", function () {
      api.rerender('661dfb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceCfdeDatasetRunCard.vue"
export default component.exports